import React, { Component } from 'react';
import OPE from 'components/common/EpiOnPageEdit';
import { HtmlComponent, HtmlComponentContainer } from 'features/HtmlComponent';
import { colors as Colors } from 'constants/colors';
import { CountyButtons } from './CountyButtons';
import { ButtonText, PrimaryButton } from 'components/button';

class ServicePageMenuBlock extends Component {
  constructor(props) {
    super(props);
    this.onClickScroll = this.onClickScroll.bind(this);
  }

  onClickScroll = () => {
    let scrollToElement = document.getElementById('formLink');
    if (scrollToElement == null) return null;
    const windowOffset = window.scrollY || window.pageYOffset;
    const { top } = scrollToElement.getBoundingClientRect();
    const scrollY = top;
    window.scroll({
      top: windowOffset + scrollY,
      behavior: 'smooth'
    });
  };

  componentDidMount() {}

  componentDidUpdate() {}

  render() {
    const { menuBlock, filter } = this.props;

    return (
      <div>
        <OPE propertyName="mainBody" floating={false}>
          <HtmlComponentContainer smallmargin="0rem 0rem 1rem 0rem" margin="0rem 0rem 1rem 0rem">
            <HtmlComponent html={menuBlock.mainBody} />
          </HtmlComponentContainer>
          <CountyButtons countyLinks={menuBlock.countyLinks} categoryList={filter.categoryList} />
          {menuBlock.formLink ? (
            <PrimaryButton
              padding="0"
              backgroundcolor={Colors.WHITE}
              border={'2px solid' + Colors.ORANGE}
              borderradius="4px"
              onClick={() => {
                this.onClickScroll();
              }}>
              <ButtonText color={Colors.BLACK}>{menuBlock.buttonText}</ButtonText>
            </PrimaryButton>
          ) : (
            menuBlock.buttonLink && (
              <PrimaryButton
                padding="0"
                backgroundcolor={Colors.WHITE}
                border={'2px solid' + Colors.ORANGE}
                borderradius="4px">
                <a href={menuBlock.buttonLink}>
                  <ButtonText color={Colors.BLACK}>{menuBlock.buttonText}</ButtonText>
                </a>
              </PrimaryButton>
            )
          )}
        </OPE>
      </div>
    );
  }
}

export default ServicePageMenuBlock;
